export default __webpack_public_path__ + "static/media/back-to-home.b0ad1c39.svg";